import { useEffect, useState } from 'react';

import { isTtqBirdsEyeZoomLevel, resolveTtqBirdsEyeMode } from './ttqibViewport';

/**
 * 品题画布 LOD 模式（一对多 vs 多对一），带 zoom 迟滞，避免阈值附近闪烁。
 * 与 TtqUnifiedCanvas、BottomMenu、面板显隐共用同一判定。
 */
export function useTtqCanvasLodMode(zoom: number | undefined): boolean {
  const [birdsEyeMode, setBirdsEyeMode] = useState(() => isTtqBirdsEyeZoomLevel(zoom ?? 1));

  useEffect(() => {
    setBirdsEyeMode((prev) => resolveTtqBirdsEyeMode(prev, zoom ?? 1));
  }, [zoom]);

  return birdsEyeMode;
}
